export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-desktop-1.0.0',
    name: 'JDSDatepickerDesktopInternal',
    platform: 'web'
  },
  hierarchy: {
    container: [
      {
        'top-container': ['left-jds_button', 'close-jds_button']
      },
      {
        'controls-container': [
          'jds_datepicker_header',
          {
            'calender-view-container': [
              'top-jds_divider',
              'jds_datepicker_calendar',
              'jds_datepicker_month_view',
              'jds_datepicker_year_view'
            ]
          }
        ]
      }
    ]
  },
  base: {
    container: {
      'background-color': '{d_4}',
      'flex-direction': '{d_5}',
      'justify-content': '{d_6}',
      'align-items': '{d_7}',
      'border-radius': '{d_8}',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000029'
      }
    },
    'top-container': {
      'flex-direction': '{d_9}',
      'justify-content': '{d_10}',
      'align-items': '{d_11}',
      'padding-top': '{d_12}',
      'padding-right': '{d_13}',
      'padding-bottom': '{d_14}',
      'padding-left': '{d_15}',
      width: '{d_16}'
    },
    jds_datepicker_header: {
      state: 'default',
      'padding-right': '{d_17}',
      'padding-left': '{d_18}'
    },
    'left-jds_button': {
      hidden: true,
      kind: 'tertiary',
      icon: 'ic_back',
      size: 'medium'
    },
    'close-jds_button': {
      kind: 'tertiary',
      icon: 'ic_close',
      size: 'medium'
    },
    'controls-container': {
      'flex-direction': '{d_19}',
      'justify-content': '{d_20}',
      'align-items': '{d_21}',
      gap: '{d_22}'
    },
    'calender-view-container': {
      'flex-direction': '{d_23}',
      'justify-content': '{d_24}',
      'align-items': '{d_25}',
      height: '{d_26}',
      width: '{d_27}'
    },
    'top-jds_divider': {
      pad: 'none',
      orientation: 'horizontal',
      hidden: true
    },
    jds_datepicker_calendar: {
      hidden: false,
      'padding-right': '{d_28}',
      'padding-left': '{d_29}',
      'padding-bottom': '{d_30}'
    },
    jds_datepicker_month_view: {
      hidden: true
    },
    jds_datepicker_year_view: {
      hidden: true
    }
  },
  variant: {
    state: {
      month_view: {
        'top-jds_divider': {
          hidden: false
        },
        'top-container': {
          'justify-content': '{d_32}'
        },
        'left-jds_button': {
          hidden: false
        },
        jds_datepicker_calendar: {
          hidden: true
        },
        jds_datepicker_month_view: {
          hidden: false
        },
        jds_datepicker_header: {
          state: 'month'
        }
      },
      year_view: {
        'top-jds_divider': {
          hidden: false
        },
        'top-container': {
          'justify-content': '{d_33}'
        },
        'left-jds_button': {
          hidden: false
        },
        jds_datepicker_calendar: {
          hidden: true
        },
        jds_datepicker_year_view: {
          hidden: false
        },
        jds_datepicker_header: {
          state: 'year'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'month_view', 'year_view']
      }
    },
    data: {
      container: {
        elementRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        '_years.yearLoadCount': {
          type: 'number',
          name: 'yearLoadCount'
        }
      },
      jds_datepicker_header: {
        month: {
          type: 'string',
          name: 'monthName'
        },
        year: {
          type: 'number',
          name: 'year'
        },
        yearSelectable: {
          type: 'boolean',
          name: 'yearSelectable'
        },
        monthSelectable: {
          type: 'boolean',
          name: 'monthSelectable'
        }
      },
      jds_datepicker_month_view: {
        months: {
          type: 'list',
          name: 'months',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_year_view: {
        current: {
          type: 'number',
          name: 'current'
        },
        loadedYears: {
          type: 'list',
          name: 'loadedYears',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_calendar: {
        day: {
          type: 'number',
          name: 'date'
        },
        month: {
          type: 'number',
          name: 'month'
        },
        year: {
          type: 'number',
          name: 'year'
        },
        selected: {
          type: 'date',
          name: 'value'
        },
        disabled: {
          type: 'object',
          name: 'calendarData',
          object: {
            disabledDays: 'list',
            disabledDates: 'list',
            max: 'date',
            min: 'date'
          }
        }
      }
    },
    events: {
      container: {
        onClick: '_onContainerClick'
      },
      'left-jds_button': {
        onClick: '_onBack'
      },
      'close-jds_button': {
        onClick: 'onClose'
      },
      jds_datepicker_header: {
        onMonthClick: '_onMonthClick',
        onYearClick: '_onYearClick',
        onPrev: '_onPrev',
        onNext: '_onNext'
      },
      jds_datepicker_month_view: {
        onSelect: '_onMonthSelect'
      },
      jds_datepicker_year_view: {
        onSelect: '_onYearSelect'
      },
      jds_datepicker_calendar: {
        onSelect: 'onSelect',
        onSwipeLeft: '_onNextCalendar',
        onSwipeRight: '_onPrevCalendar'
      }
    },
    a11y: {
      'left-jds_button': {
        properties: {
          ariaLabel: {
            name: 'previousButtonAriaLabel',
            value: 'Click to Return'
          }
        }
      },
      'close-jds_button': {
        properties: {
          ariaLabel: {
            name: 'closeAriaLabel',
            value: 'Click to Close'
          }
        }
      },
      jds_datepicker_header: {
        properties: {
          previousAriaLabel: 'previousMonthAriaLabel',
          nextAriaLabel: 'nextMonthAriaLabel'
        }
      }
    }
  }
};
